import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

// US-6.2 GET /api/v1/RequirementProfile (optional ?frameworkId) ->
// ApiBaseResponse<IEnumerable<RequirementProfileResponse>> i.e. { data: [...] }.
export const getRequirementProfile = createAsyncThunk(
  "RequirementProfile/get",
  async (frameworkId, { rejectWithValue }) => {
    try {
      const url = frameworkId
        ? `${API_URL.REQUIREMENT_PROFILE.SLUG}?frameworkId=${frameworkId}`
        : `${API_URL.REQUIREMENT_PROFILE.SLUG}`;
      const { data } = await axios.get(url);
      return data?.data || [];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createRequirementCell = createAsyncThunk(
  "RequirementProfile/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.REQUIREMENT_PROFILE.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const updateRequirementCell = createAsyncThunk(
  "RequirementProfile/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.REQUIREMENT_PROFILE.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteRequirementCell = createAsyncThunk(
  "RequirementProfile/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${API_URL.REQUIREMENT_PROFILE.SLUG}/${id}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const requirementProfileSlice = createSlice({
  name: "requirementProfile",
  initialState: {
    profile_list: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRequirementProfile.fulfilled, (state, action) => {
      state.profile_list = action.payload || [];
    });
  },
});

export default requirementProfileSlice.reducer;
